import { ApiErrorCode, withApiErrorHandler } from '@/modules/common/api/errors';
import { axiosInstance } from '@/utils/axios';

/**
 * Complete the onboarding process and transition user to main application flow.
 *
 * This endpoint finalizes the onboarding sequence by:
 * - Marking the user's onboarding as completed in the backend
 * - Updating user status to enable access to main application features
 * - Triggering any necessary post-onboarding setup processes
 *
 * @returns Promise that resolves on successful completion
 */
export const completeOnboarding = async (): Promise<void> => {
  const endpoint = '/api/onboarding/complete';

  await withApiErrorHandler(endpoint, ApiErrorCode.ONBOARDING_COMPLETE_FAILED, () =>
    axiosInstance.post(endpoint)
  );
};
